import axios from "axios";
import baseURL from "./../api";
class PaymentMethodsService {

    getPaymentMethods(id) {
        return axios.get(`${baseURL}/user/payment-methods${id ? "?agentId="+id : ""}`);
    }

    addPaymentMethod(data,id) {
        return axios.post(`${baseURL}/user/payment-method${id ? "?agentId="+id:""}`, data);
    }

    deletePayment(id,agentId) {
        return axios.delete(`${baseURL}/user/payment-method/${id}/delete${agentId ? "?agentId="+agentId:""}`);
    }

    suspendPayment(id) {
        return axios.post(`${baseURL}/user/payment-method/${id}/suspend`);
    }

    resumePayment(id) {
        return axios.post(`${baseURL}/user/payment-method/${id}/resume`);
    }


    getAdminPaymentMethods(id) {
        return axios.get(`${baseURL}/system/payment-methods${id ? "?agentId="+id:""}`);
    }

    suspendPaymentMethod(id) {
        return axios.post(`${baseURL}/system/payment-method/${id}/suspend`);
    }

    resumePaymentMethod(id) {
        return axios.post(`${baseURL}/system/payment-method/${id}/resume`);
    }
    suspendPaymentMethodID(id) {
        return axios.post(`${baseURL}/user/payment-method-type/${id}/suspend`);
    }

    resumePaymentMethodID(id) {
        return axios.post(`${baseURL}/user/payment-method-type/${id}/resume`);
    }
}
export default new PaymentMethodsService();